// @flow
import ClientConfigService from 'common/services/ClientConfigService';

import {
    PersonnelTypeEnum,
    type PersonnelTypeEnumType
} from 'common/enums/PersonnelEnums';

import { EntitySettings } from 'common/models/internal/EntitySettings';

export const isTransporterPersonnelEnabled = (
    entitySettings: EntitySettings
): boolean => {
    return (
        ClientConfigService.isRbacEnabled() &&
        entitySettings.personnelSettings.enableTransporterPersonnel
    );
};

export const isFieldHidden = (
    column: string,
    params: ?{
        personnelType?: PersonnelTypeEnumType,
        entitySettings: EntitySettings
    } = {}
): boolean => {
    const { personnelType, entitySettings } = params;

    if (['roleMasterId', 'roleMasterName'].includes(column)) {
        return !ClientConfigService.isRbacEnabled();
    }

    if (
        [
            'canVerifyEntities',
            'canManageEntities',
            'canManagePersonnel',
            'accessType'
        ].includes(column)
    ) {
        return ClientConfigService.isRbacEnabled();
    }

    const isTransporterEnabled = isTransporterPersonnelEnabled(entitySettings);

    if (column === 'personnelType') {
        return !isTransporterEnabled;
    }

    if (column === 'transporters') {
        return !(
            isTransporterEnabled &&
            (!personnelType || personnelType === PersonnelTypeEnum.TRANSPORTER)
        );
    }

    if (
        isTransporterEnabled &&
        ['hasAllTeamsAccess', 'teams'].includes(column)
    ) {
        return !(!personnelType || personnelType === PersonnelTypeEnum.CLIENT);
    }

    return false;
};
